import {
  Link
} from '@mui/material'
import {
  useSelector,
  useDispatch
} from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {
  clearFlashAlert,
  clearFlashNotice,
  setFlashAlert,
  setFlashNotice
} from '../ui/uiSlice'
import {
  selectAuthToken,
  clearUserData,
} from './userSlice'
import {
  deviseFetch,
  showFailedRequest,
  refreshCsrfToken,
} from '../../../components/devise/deviseRequest'
import { formatDeviseErrors } from '../../../components/devise/deviseErrors'
import { clearPagesData } from '../pages/pagesSlice'
import { clearStikisData } from '../stikis/stikisSlice'
import { clearSharesData } from '../shares/sharesSlice'

const classes = {
  link: {
    margin: '0 5px 0 5px',
    cursor: 'pointer',
  },
}

export default function SignOut() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const authToken = useSelector(selectAuthToken) || ''

  const handleClick = async (e) => {
    e.preventDefault()
    console.log('handleSignOut()')

    dispatch(clearFlashNotice())
    dispatch(clearFlashAlert())

    const result = await deviseFetch(dispatch, "/user/sign_out.json", {
      method: "DELETE",
      headers: {
        "X-CSRF-Token": authToken,
      },
      credentials: "same-origin",
    })

    // A failure (the server didn't answer, or the CSRF token was stale) leaves
    // the user signed in with a message; they can click Sign Out again.
    if (result.failure) {
      showFailedRequest(dispatch, result)
      return
    }
    const { response } = result

    console.log(response.status)

    // 204 is a sign out. 401 (with no body) is Devise saying nobody is signed in
    // on the server, say because the session has ended or its cookie is gone.
    // Either way the user is signed out, so the app should show that; leaving
    // the signed-in screens up would just fail on every click.
    if (response.status === 204 || response.status === 401){
      console.log('signed out', response.status)
      dispatch(clearUserData())
      dispatch(clearPagesData())
      dispatch(clearStikisData())
      dispatch(clearSharesData())
      dispatch(setFlashNotice(
        response.status === 204 ? 'Signed out' : 'You were already signed out.'
      ))
      if (response.status === 401) {
        // The old token belonged to the ended session: get one for the new
        // one, so the next sign in works first time. (No await: the flash must
        // be set in the same run as the navigation.)
        refreshCsrfToken(dispatch)
      }
      navigate('/app/welcome')
      return
    }

    // Otherwise, it is an unexpected response (say a 500 page): say so.
    dispatch(setFlashAlert(formatDeviseErrors(result.json)))

  }

  return (
    <Link 
      sx={classes.link} 
      onClick={handleClick} 
      rel='nofollow'
      color='inherit'
    >
      Sign Out
    </Link>
  )
}